export default "__VITE_ASSET__dYJTN4m6__"